import { PropStatusColor } from 'sos-models';
import axios from '../../config/axios';

export function list(): Promise<Partial<PropStatusColor>[]> {
	return axios
		.get<Partial<PropStatusColor>[]>('/api/prop-status-colors')
		.then((response) => response.data);
}
